/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  plugin_helper.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:29
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import objectAssign from 'object-assign'

const mergeOptions = function ($vm: any, options: {[prop: string]: any}) {
  const defaults: {[prop: string]: any} = {}
  for (let i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default
    }
  }
  const _options = objectAssign({}, defaults, options)
  for (let i in _options) {
    $vm[i] = _options[i]
  }
}

export {
  mergeOptions
}
